// Lightweight helper for firing Google Ads conversions. Safe if gtag is not present.

export const AW_ID = "AW-18335773343";
export const CONVERSIONS = {
    contact: `${AW_ID}/_xjkCMCZi9YcEJ_llqdE`,
};

export function trackConversion(sendTo, extra = {}) {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    try {
        window.gtag("event", "conversion", { send_to: sendTo, ...extra });
    } catch {
        /* no-op */
    }
}

export const trackContactConversion = (extra = {}) => trackConversion(CONVERSIONS.contact, extra);
